module.exports = __webpack_public_path__ + "img/T1C_rc_27.7abc891f.png";